import React from 'react';

function Footer() {
  return (
    <div>
      <div className='footer'>
        <div className='right'>
          <p>Copyright © 2025, SCI MAYEDO</p>
        </div>

        <div className="foot--content">
          <div className='schedule'>
            <h4 className='footer__title'>Horaire d'ouverture</h4>
            <p>Lundi-Vendredi : 8h-16h</p>
            <p>Samedi : 9h-12h</p>
          </div>
          
          <div className='address'>
            <h4 className='footer__title'>Contactez-nous</h4>
            <p><i className="fa-solid fa-location-dot"></i> Cocody Angré 7eme Tranche / Abidjan – Plateau – 01 BP 2076 Abidjan 01</p>
            <p><i className="fa-solid fa-phone"></i> +225 07 88 88 88 71</p>
            <p><i className="fa-solid fa-envelope"></i> sci@mayedo.ci</p>
            <p><i className="fa-solid fa-globe"></i> www.mayedo.ci</p>
          </div>

          <div className='social--media'>
            <h4 className='footer__title'>Réseaux sociaux</h4>
            <p><i className="fa-brands fa-facebook"></i> Facebook</p>
            <p><i className="fa-brands fa-instagram"></i> Instagram</p>
            <p><i className="fa-brands fa-whatsapp"></i> WhatsApp</p>
            <p><i className="fa-brands fa-tiktok"></i> TikTok</p>
          </div>
        </div>

        <div className='name--developer'>
          <p>Developed by Doumbia Fode (+225 0777880082)</p>
        </div>
      </div>

      {/* CSS intégré */}
      <style>{`
        .footer {
          width: 100%;
          background-color: #ffffffff;
          padding: 20px 40px;
          box-sizing: border-box;
          font-family: 'Segoe UI', Tahoma, sans-serif;
        }
        .right {
          text-align: center;
          margin-bottom: 20px;
          font-weight: bold;
          color: #0c3467;
        }
        .foot--content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        .foot--content > div {
          flex: 1 1 250px;
          margin: 10px;
        }
        .footer__title {
          font-weight: bold;
          margin-bottom: 10px;
          color: #0c3467;
        }
        .foot--content p {
          margin: 5px 0;
          color: #333;
          font-size: 0.95rem;
        }
        .foot--content i {
          margin-right: 8px;
          color: #0c3467;
        }
        .social--media p i {
          color: #0c3467;
        }
        .name--developer {
          text-align: center;
          font-weight: bold;
          color: #0c3467;
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .foot--content {
            flex-direction: column;
            align-items: center;
          }
          .foot--content > div {
            margin: 10px 0;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
}

export default Footer;